const typography: any = {
  fontFamily: "'Figtree', 'DM Sans', sans-serif;",
  h1: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontWeight: 600,
    fontSize: '2.25rem',
    lineHeight: '2.75rem',
  },
  h2: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontWeight: 600,
    fontSize: '1.875rem',
    lineHeight: '2.25rem',
  },
  h3: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
  },
  h4: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontWeight: 600,
    fontSize: '1.3125rem',
    lineHeight: '1.6rem',
  },
  h5: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: '1.6rem',
  },
  h6: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.2rem',
  },
  button: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    textTransform: 'capitalize',
    fontWeight: 400,
  },
  body1: {
    fontFamily: "'DM Sans', 'Figtree', sans-serif",
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.334rem',
  },
  body2: {
    fontFamily: "'DM Sans', 'Figtree', sans-serif",
    fontSize: '0.75rem',
    letterSpacing: '0rem',
    fontWeight: 400,
    lineHeight: '1rem',
  },
  subtitle1: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontSize: '0.875rem',
    fontWeight: 400,
  },
  subtitle2: {
    fontFamily: "'Figtree', 'DM Sans', sans-serif",
    fontSize: '0.675rem',
    fontWeight: 400,
  },
};

export default typography;
